module.exports = __webpack_public_path__ + "static/media/people.0df6c39b.png";